import React, { useState, useEffect, useCallback } from "react";
import { Modal, Button } from "react-bootstrap";
import { createModal } from "react-modal-promise";
import locationImg from "../../../images/location_pin.png";

var map;
var marker;
var popup;

const ArriveMapPop = ({ dprtLatt, dprtLont }) => {
  const [show, setShow] = useState(true);
  const { Tmapv2 } = window;

  //코드 및 그리드 초기화 및 생성
  useEffect(() => {
    const initMap = () => {
      map = new window.Tmapv2.Map("map_div", {
        center: new window.Tmapv2.LatLng(dprtLatt, dprtLont), // 지도 초기 좌표
        // width: "100%",
        height: "300px",
        zoom: 17,
      });

      marker = new Tmapv2.Marker({
        position: new Tmapv2.LatLng(dprtLatt, dprtLont),
        map: map,
      });

      popup = new Tmapv2.InfoWindow({
        position: new Tmapv2.LatLng(dprtLatt, dprtLont), //Popup 이 표출될 맵 좌표
        type: 2,
        map: map, // 지도 객체
      });
    };

    initMap();
  }, []);
  const handleClose = (returnData) => {
    setShow(false);
  };

  const handleOk = (returnData) => {
    setShow(false);
  };

  const setMapCenter = () => {
    //console.log("lat === " + dprtLatt + " || lon === " + dprtLont);

    map.setCenter(new Tmapv2.LatLng(dprtLatt, dprtLont));
    map.setZoom(17);
    marker.setPosition(new Tmapv2.LatLng(dprtLatt, dprtLont));
    popup.setPosition(new Tmapv2.LatLng(dprtLatt, dprtLont));
  };

  return (
    <>
      <Modal show={show} onHide={() => handleClose(false)} size="clg">
        <Modal.Header closeButton>
          <Modal.Title>위치 보고 위치</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <table className="t_garo">
            <tr>
              <th style={{ textAlign: "center", padding: "0" }}>
                <img src={locationImg} style={{ verticalAlign: "middle" }} />
                상세지도
              </th>
            </tr>
            <tr>
              <td style={{ padding: "0" }}>
                <div id="map_div" style={{ height: "100%" }}></div>
              </td>
            </tr>
          </table>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => handleOk(true)}>
            확인
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export const ModalDepartureMapPop = createModal(ArriveMapPop);

export default ArriveMapPop;
